var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-circle",style:({ backgroundColor: _vm.value }),attrs:{"title":"Seleccionar color"}},[_c('input',{attrs:{"type":"color"},domProps:{"value":_vm.value},on:{"input":_vm.updateColor}})])
}
var staticRenderFns = []

export { render, staticRenderFns }